export const selectComplianceData = (state) => state.overallCompliance?.complianceData;
export const selectLoading = (state) => state.overallCompliance?.loading;
export const selectError = (state) => state.overallCompliance?.error;
export const selectTotalSamplesTested = (state) => 
  state.overallCompliance?.complianceData?.totalSamplesTested || 0;

export const selectCompliantSamples = (state) => 
  state.overallCompliance?.complianceData?.compliantSamples || { count: 0, percentage: 0 };

export const selectUnsafeSamples = (state) => 
  state.overallCompliance?.complianceData?.unsafeSamples || { count: 0, percentage: 0 };

export const selectSubStandardSamples = (state) => 
  state.overallCompliance?.complianceData?.subStandardSamples || { count: 0, percentage: 0 };

export const selectMisLabelledSamples = (state) => 
  state.overallCompliance?.complianceData?.misLabelledSamples || { count: 0, percentage: 0 };